import pb from '../lib/pocketbase.js';

// Obtener los drops de egreso paginados
export async function getEgresoDrops(egresoCabId, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('egresoDrop').getList(page, perPage, {
      filter: `egresoCab = "${egresoCabId}"`,
      $autoCancel: false,
      expand: "delivery,vehiculo,transporte",
      timeout: 10000 // 10 second timeout
    });
    return {
      items: response.items || [],
      totalItems: response.totalItems || 0,
      page: response.currentPage || 1,
    };
  } catch (error) {
    console.error("Error fetching egresoDrop:", error);
    // Return empty result instead of throwing to prevent cascade failures
    return {
      items: [],
      totalItems: 0,
      page: 1,
    };
  }
}

// Crear un nuevo drop de egreso
export async function createEgresoDrop(egresoDrop) {
  try {
    const response = await pb.collection('egresoDrop').create(egresoDrop);
    return response;
  } catch (error) {
    console.error("Error creating egresoDrop:", error);
    throw new Error("Error al crear el drop de egreso");
  }
}

// Actualizar un drop de egreso existente
export async function updateEgresoDrop(id, egresoDrop) {
  try {
    const response = await pb.collection('egresoDrop').update(id, egresoDrop);
    return response;
  } catch (error) {
    console.error("Error updating egresoDrop:", error);
    throw new Error("Error al actualizar el drop de egreso");
  }
}

// Eliminar un drop de egreso
export async function deleteEgresoDrop(id) {
  try {
    await pb.collection('egresoDrop').delete(id);
  } catch (error) {
    console.error("Error deleting egresoDrop:", error);
    throw new Error("Error al eliminar el drop de egreso");
  }
}

// Obtener un drop de egreso por ID
export async function getEgresoDropById(id) {
  try {
    const response = await pb.collection('egresoDrop').getOne(id, {
      expand: "delivery,vehiculo,transporte"
    });
    return response;
  } catch (error) {
    console.error("Error fetching egresoDrop by ID:", error);
    throw new Error("Error al obtener el drop de egreso");
  }
}

// Buscar drops de egreso por referencia con paginación
export async function searchEgresoDrops(query, egresoCabId, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('egresoDrop').getList(page, perPage, {
      filter: `(target_ref ~ "${query}" || delivery_ref ~ "${query}" || transporte_ref ~ "${query}") && egresoCab = "${egresoCabId}"`,
      expand: "delivery,vehiculo,transporte"
    });
    return {
      items: response.items,
      totalItems: response.totalItems,
      currentPage: response.currentPage,
    };
  } catch (error) {
    console.error("Error searching egresoDrops:", error);
    throw new Error("Error al buscar los drops de egreso");
  }
} 